<template>
  <div class="my-1 my-lg-2">
    <div class="h-100 p-3 bg-white box-shadow drag-box text-center">
      <div class="upload">
        <ul class="list-inline list-unstyled" v-if="files.length">
          <li v-for="file in files" :key="file.id" class="list-inline-item p-2">
            <img :src="file.thumb" />
          </li>
        </ul>
        
        <ul class="empty" v-else>
          <i class="fas fa-upload " />
          <h3 >
            Upload Photos
          </h3>
          <div v-if="!isMobile">
            <span>
              Drag and drop files here
            </span>
            <span>
              OR
            </span>
          </div>
          <label
            class="Button"
            for="file"
            >
            Browse Files
          </label
          >
        </ul>

        <div
          v-show="$refs.upload && $refs.upload.dropActive"
          class="drop-active"
        >
          <h3>Drop files to upload</h3>
        </div>
        <div class="example-btn">
          <file-upload
            class="btn btn-primary d-none"
            post-action="/upload/post"
            :multiple="true"
            :drop="true"
            :drop-directory="true"
            v-model="files"
            @input-filter="inputFilter"
            ref="upload"
          >
            <i class="fa fa-plus"></i>
            Select files
          </file-upload>
          <!--
            Don't let the user advance to the uploader while images are still
            compressing (pendingCompressions > 0, from UploaderMixins). Their
            ImageFile payloads aren't ready yet; advancing early is the front
            edge of the silent-drop race. The uploader's save-time guard is the
            hard backstop, but blocking here keeps the flow honest.
          -->
          <router-link
            type="button"
            class="Button mb-3"
            v-if="files.length && pendingCompressions === 0"
            :to="{ name: 'PhotoUploader', params: { files: files, passedMachine: null }}"
          >
            Next
            <i class="fas fa-arrow-right"></i>
          </router-link>
          <button
            type="button"
            class="Button mb-3"
            v-else-if="files.length"
            disabled
          >
            Processing images…
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// https://github.com/lian-yue/vue-upload-component
import FileUpload from "vue-upload-component";
import UploaderMixins from "../mixins/UploaderMixins.js";

export default {
  name: "PhotoSelector",
  mixins: [UploaderMixins],
  components: {
    FileUpload,
  },
  data() {
    return {
      files: [],
    };
  },
  // Because Home is kept-alive in App.vue, this component is not re-created
  // when the user navigates back to the home page after uploading. Clear any
  // files left over from a prior upload session so the page is ready for a
  // fresh add every time the user returns.
  activated() {
    this.files = [];
  },
};
</script> 

<style  lang="scss" scoped>

.upload {

  .Button{
      background-color: $titan-blue;
      color: $white;
      text-transform: uppercase;
      text-decoration: none;
      padding: 7px 55px;
      transition: all 300ms ease;
      border: 1px solid transparent;

      &:hover{
        color: $titan-blue;
        background-color: transparent;
        border: 1px solid $titan-blue;
        cursor: pointer;
      }
    }

  .empty{
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 30px 0;
    align-items: center;

    i{
      color: $titan-blue;
      font-size: 30px;
    }

    h3{
      color: $titan-blue;
      margin: 0;
      margin-top: 5px;
    }

    div{
      display: flex;
      flex-direction: column;
      margin-top: 5px;
      
      span{
        color: #777777;
        &:nth-child(2){
          padding-block: 20px;
        }
      }
    }

    .gonsalo{
      background-color: $titan-blue;
      color: $white;
      text-transform: uppercase;
      padding: 7px 55px;
      transition: all 300ms ease;
      border: 1px solid transparent;

      &:hover{
        color: $titan-blue;
        background-color: transparent;
        border: 1px solid $titan-blue;
        cursor: pointer;
      }
    }
  }

  img {
    max-width: 150px;
  }
}

.drag-box {
  outline: 1px dashed #DDDDDD;
  outline-offset: -15px;

  label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
  }

  .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: 0.6;
    text-align: center;
    background: #000;
  }

  .drop-active h3 {
    margin: -0.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
}


</style>